import { render, staticRenderFns } from "./PopupAddNewStaff.vue?vue&type=template&id=91f66648&scoped=true"
import script from "./PopupAddNewStaff.vue?vue&type=script&lang=js"
export * from "./PopupAddNewStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f66648",
  null
  
)

export default component.exports